import React, { useEffect, useState } from 'react';
import BlogList from '../components/BlogList';
import githubIcon from '../assets/icons/github.svg';
import authService from '../services/authService';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        // Check authentication status
        const checkAuth = () => {
            try {
                const user = authService.getCurrentUser();
                const isAuth = localStorage.getItem('isAuthenticated') === 'true';
                
                console.log('Dashboard auth check:', { user, isAuth });
                
                if (!user || !isAuth) {
                    console.log('Not authenticated, redirecting to login');
                    // Not authenticated, redirect to login
                    navigate('/login');
                    return;
                }
                console.log('Authentication successful, setting state');
                setIsAuthenticated(true);
                setCheckingAuth(false);
            } catch (error) {
                console.error('Auth check error:', error);
                // Clear any invalid data and redirect to login
                localStorage.removeItem('user');
                localStorage.removeItem('isAuthenticated');
                localStorage.removeItem('csrf_token');
                navigate('/login');
            }
        };

        checkAuth();
    }, [navigate]);

    useEffect(() => {
        const shouldScroll = sessionStorage.getItem('scrollToContact');
        if (shouldScroll === 'true') {
            const contactSection = document.getElementById('contact');
            if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
            }
            sessionStorage.removeItem('scrollToContact');
        }
    }, []);

    // Check for refresh flag from BlogWriting
    useEffect(() => {
        const shouldRefresh = sessionStorage.getItem('refreshDashboard');
        if (shouldRefresh === 'true') {
            setRefreshTrigger(prev => prev + 1);
            sessionStorage.removeItem('refreshDashboard');
        }
    }, []);

    // Show loading while checking authentication
    if (checkingAuth) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-11 px-2 px-md-1">
                        <div className="text-center">
                            <p>Checking authentication...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // If not authenticated, don't render anything (will redirect to login)
    if (!isAuthenticated) {
        return null;
    }

    return (
        <div className="Blogs-wrapper container mt-5">
            <div className="row justify-content-center">
                <div className="col-11 px-2 px-md-1">

                    {/* Header */}
                    <div className="header-section">
                        <div>
                            <h1 className='header-name mb-4 mb-md-3'>Dashboard</h1>
                            <div className="d-flex justify-content-between align-items-center pt-4 pt-sm-5">
                                <div className="flex-shrink-0">
                                    <button
                                        type="button"
                                        className="btn"
                                        onClick={() => window.location.href = '/BlogWriting'}
                                    >
                                        New post
                                    </button>
                                </div>
                                <div className='d-flex gap-3 flex-shrink-0'>
                                    <button 
                                        type="button" 
                                        className="btn"
                                        onClick={() => window.location.href = '/home'}
                                    >
                                        Back
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn"
                                        onClick={async () => {
                                            await authService.logout();
                                            navigate('/login');
                                        }}
                                    >
                                        Logout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Blog list */}
                    <div className="blog-list-section">
                        <div>
                            <h1 className='header-name mb-4 mb-md-5'>Published Posts</h1>
                            <BlogList showActions={true} refreshTrigger={refreshTrigger} showAllPosts={true} filterPublished={1} />
                        </div>
                    </div>

                    {/* Draft list */}
                    <div className="blog-list-section">
                        <div>
                            <h1 className='header-name mb-4 mb-md-5'>Drafts</h1>
                            <BlogList showActions={true} refreshTrigger={refreshTrigger} showAllPosts={true} filterPublished={0} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
